import React from 'react';
import { Link } from 'react-router-dom';

const ProductsTable = ({
  products = [],
  loading = false,
  onStatusChange,
}) => {
  if (loading) {
    return <p className="product-table-message">Loading products...</p>;
  }

  if (products.length === 0) {
    return (
      <div className="product-empty-state">
        <h3>No products found</h3>
        <p>Create your first product to get started.</p>
      </div>
    );
  }

  return (
    <div className="product-table-wrapper">
      <table className="product-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>SKU</th>
            <th>Brand</th>
            <th>Category</th>
            <th>Unit</th>
            <th>GST</th>
            <th>Low Stock Alert</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {products.map((product) => (
            <tr key={product.id}>
              <td>
                <strong>{product.product_name}</strong>
                {product.hsn_code && (
                  <small className="product-secondary-text">
                    HSN: {product.hsn_code}
                  </small>
                )}
              </td>

              <td>{product.sku}</td>
              <td>{product.brand || '—'}</td>
              <td>{product.category || '—'}</td>
              <td>{product.unit}</td>
              <td>{Number(product.gst_rate)}%</td>
              <td>{Number(product.low_stock_alert)}</td>

              <td>
                <span
                  className={`product-status ${
                    product.is_active ? 'is-active' : 'is-inactive'
                  }`}
                >
                  {product.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>

              <td>
                <div className="product-row-actions">
                  <Link
                    className="product-edit-link"
                    to={`/user/products/${product.id}/edit`}
                  >
                    Edit
                  </Link>

                  <button
                    type="button"
                    className="product-status-button"
                    disabled={product.statusUpdating}
                    onClick={() => onStatusChange(product)}
                  >
                    {product.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductsTable;